import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import CloseIcon from "@mui/icons-material/Close"
import ReplyIcon from "@mui/icons-material/Reply"
import { MONO, CHAT_COLOR } from "../constants"

export function ReplyBar({ replyTo, onCancel, profiles }) {
  if (!replyTo) return null
  const displayName = profiles?.[replyTo.username]?.display_name ?? replyTo.username
  return (
    <Box sx={{ borderTop: "1px solid rgba(var(--app-fg-rgb),0.05)", px: 1.25, py: 0.5,
      display: "flex", alignItems: "center", gap: 0.75,
      backgroundColor: "var(--app-paper)", flexShrink: 0 }}>
      <ReplyIcon sx={{ fontSize: 12, color: CHAT_COLOR, opacity: 0.7 }} />
      <Typography sx={{ flex: 1, fontFamily: MONO, fontSize: "0.62rem", color: "rgba(var(--app-fg-rgb),0.45)",
        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        <span style={{ color: CHAT_COLOR }}>{displayName}</span>: {replyTo.text}
      </Typography>
      <IconButton size="small" onClick={onCancel} sx={{ p: 0, color: "rgba(var(--app-fg-rgb),0.28)", "&:hover": { color: "var(--app-error)" } }}>
        <CloseIcon sx={{ fontSize: 11 }} />
      </IconButton>
    </Box>
  )
}
